import { formatDisplayDate } from "../../services/apiClient";
import "./CaptionPublishingHistory.scss";

const getStatusLabel = (status) => {
  if (status === "completed") {
    return "Completed";
  }

  if (status === "failed") {
    return "Failed";
  }

  if (status === "processing") {
    return "Processing";
  }

  return "Pending";
};

const CaptionPublishingHistory = ({
  jobs = [],
  selectedJobId,
  onSelectJob,
  onCreateNew,
  isLoading,
  errorMessage,
}) => (
  <aside className="caption-history">
    <div className="caption-history__header">
      <h3 className="caption-history__title">Your uploads</h3>
      <button type="button" className="caption-history__new-btn" onClick={onCreateNew}>
        + New
      </button>
    </div>

    {isLoading && <p className="caption-history__message">Loading your uploads...</p>}
    {errorMessage && <p className="caption-history__error">{errorMessage}</p>}

    {!isLoading && !jobs.length && !errorMessage && (
      <p className="caption-history__message">No uploads yet. Generate your first caption job.</p>
    )}

    <div className="caption-history__list">
      {jobs.map((job) => (
        <button
          key={job.jobId}
          type="button"
          className={`caption-history__item ${selectedJobId === job.jobId ? "caption-history__item--active" : ""}`}
          onClick={() => onSelectJob(job)}
        >
          <div className="caption-history__item-top">
            <span className="caption-history__file-name">
              {job.title || job.videoFileName || "Untitled video"}
            </span>
            <span className={`caption-history__status caption-history__status--${job.status || "pending"}`}>
              {getStatusLabel(job.status)}
            </span>
          </div>
          <p className="caption-history__date">{formatDisplayDate(job.createdAt || job.updatedAt)}</p>
        </button>
      ))}
    </div>
  </aside>
);

export default CaptionPublishingHistory;
